module.exports = __webpack_public_path__ + "files/343ed8348dd5d171bd9ad4e8c8b68e3c.png";